<template>
  <v-container fluid class="fill-height pa-0 ma-0 overflow-auto">
    <v-row class="ma-0 fill-height p-relative">
      <v-container fluid class="p-absolute fill-height">
        <v-row class="ma-0 pa-0 fill-height p-relative flex-nowrap">
          <v-col cols="2">
            <slot name="first-column" />
          </v-col>
          <v-col
            v-for="(itemData, i) in listDatesWithDemand"
            :key="i + itemData.dayText + '1'"
            cols="2"
            class="bordered-col"
          >
            <v-item-group>
              <v-item>
                <div class="div-dias-semana">
                  <span class="text-datas-extenso text-capitalize">
                    {{ itemData.semanaText }}
                  </span>
                  <span class="pl-2 text-datas-number">
                    {{ itemData.dayText }}
                  </span>
                </div>
              </v-item>
            </v-item-group>
          </v-col>
        </v-row>
      </v-container>
      <slot />
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "GridViewPlantsWithDates",
  data() {
    return {};
  },
  async created() {
    await this.ActionLoadCities();
    await this.ActionLoadSlaughterPlantEstablishments();
  },
  computed: {
    ...mapState("programacaoAbate", [
      "listDatesWithDemand",
      "programacaoAbateSelected",
    ]),
  },
  methods: {
    ...mapActions("programacaoAbate", [
      "ActionLoadSlaughterPlantEstablishments",
      "ActionLoadCities",
    ]),
  },
};
</script>

<style></style>
